import { render, staticRenderFns } from "./ticket-list.component.vue?vue&type=template&id=7df82407"
import script from "./ticket-list.component.vue?vue&type=script&lang=js"
export * from "./ticket-list.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports